import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import styles from './ReportForm.module.css';
import { UserService } from '../../../support/services/api';
import validate, { passwordSchema } from '../../../support/services/validation';
import { LoadingDots } from '..';
import { updateToken } from '../../../support/store/AuthReducer';

export default function RefreshToken({ request, response }) {
  const [reportStatus, setReportStatus] = useState('initial');
  const [password, setPassword] = useState('');
  const [newToken, setToken] = useState();
  const email = useSelector(((state) => state.AuthReducer.userData.email));
  const queryClient = useQueryClient();
  const [inputError, setInputError] = useState({});
  const dispatch = useDispatch();

  const getNewToken = async () => {
    try {
      await validate(passwordSchema, password);
      setReportStatus('logging');
      const { token } = await UserService(true).login({ email, password });
      if (token) {
        dispatch(updateToken(token));
        setToken(token);
        queryClient.invalidateQueries();
      }
      setReportStatus('done');
    } catch (error) {
      setReportStatus('initial');
      setInputError({ password: error.name === 'ValidationError' ? error.message : 'Senha incorreta' });
      throw error;
    }
  };

  useEffect(() => {
    setInputError({});
  }, [password]);

  useEffect(() => {
    if (reportStatus === 'done') {
      toast.dismiss();
      toast(
        (<div className={styles.componentContainer}>
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              Login realizado com
              <strong> sucesso</strong>
              !
            </p>
          </div>
         </div>),
        { type: toast.TYPE.INFO, autoClose: true },
      );
    }
  }, [reportStatus]);

  return (
    <div className={styles.componentContainer}>
      {{
        initial: (
          <div className={styles.reportFormContainer}>
            <p className={styles.explainingText}>
              Sua sessão expirou, é necessário inserir novamente a sua senha para continuar.
            </p>
            <div className={styles.reportFormInputs}>
              <div className={styles.floatingLabelInput}>
                <input
                  required
                  placeholder="Senha"
                  id="password"
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label htmlFor="name">
                  Senha
                  <span className={styles.inputError}>
                    {inputError.password ? '- ' : ''}
                    {inputError.password}
                  </span>
                </label>
              </div>
            </div>

            <div className={styles.reportFormOptions}>
              <button type="button" className={styles.primaryButton} onClick={getNewToken}>
                Login
              </button>
            </div>
          </div>
        ),
        logging: (
          <div className={styles.reportMessageContainer}>
            <p className={styles.explainingText}>
              Fazendo Login
              <LoadingDots />
            </p>
            <p className={styles.explainingText}>
              (isso pode levar alguns segundos)
            </p>
          </div>
        ),
      }[reportStatus]}
    </div>
  );
}

RefreshToken.propTypes = {
  request: PropTypes.shape({
    url: PropTypes.string,
    method: PropTypes.string,
    data: PropTypes.string,
  }).isRequired,
  response: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string,
    statusCode: PropTypes.number,
    validation: PropTypes.shape({
      keys: PropTypes.array,
    }),
  }).isRequired,
};
